export const get = <R = any, T = any>(obj: T, path: Paths<T>): R => {
    const pathKeys = path as string[];
    return obj
        ? pathKeys.reduce<any>((result, key) => result[key] ?? null, obj)
        : null;
};

export const omit = <T, key extends keyof T>(
    obj: T,
    keys: key[]
): Omit<T, key> => {
    return keys.reduce<any>((result, key) => {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { [key]: _, ...rest } = result;
        return rest;
    }, obj);
};

export const pick = <T, key extends keyof T>(
    obj: T,
    keys: key[]
): Pick<T, key> => {
    return keys.reduce(
        (result, key) => ({ ...result, [key]: obj[key] }),
        {} as Pick<T, key>
    );
};

export const typedKeys = <T>(value: T): Array<keyof T> => {
    return Object.keys(value) as Array<keyof T>;
};

export const isDefined = (value: unknown) => value !== undefined;
